/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Typography,
  Form,
  message,
} from 'antd';
import { checkToken } from 'api/utils';
import Table from 'components/Table';
import { getPruebas, getSolicitudPrueba, getSolicitudPruebas } from 'api/catalogos/Pruebas';
import { getCandidatovistaOptimized } from 'api/catalogos/Candidatos';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { getPuestos } from 'api/catalogos/puestos';
import { getAreas } from 'api/catalogos';
import { getPlazas } from 'api/catalogos/plazas';

import { getSolicitudDeContratacionvistaOptimized } from 'api/reclutamiento/SolicitudesDeContratacion';
import { UsergroupAddOutlined } from '@ant-design/icons';
import AsignarPruebasPorVacanteModal from './AsignarPruebasPorVacanteModal';

const { Title } = Typography;

export default function PruebasPage({ vacanteId }) {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [vacanteSeleccionada, setVacanteSeleccionada] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [pruebasvacantes, setPruebasVacantes] = useState([]);
  const [data, setData] = useState([]);
  const [vacantes, setVacantes] = useState([]);
  const [areas, setAreas] = useState([]);
  const [plazas, setplazas] = useState([]);
  const [puestos, setPuestos] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [_vacantes, _pruebasCatalogo, _asignaciones] = await Promise.all([
        getSolicitudDeContratacionvistaOptimized(), // datos de vacantes
        getPruebas(), // catálogo de pruebas
        getSolicitudPruebas(), // todas las asignaciones
      ]);
      // 🔗 Filtrar solo las asignaciones de esta vacante
      const asignacionesDeEstaVacante = _asignaciones.filter(
        (a) => a.solicitud_de_contratacion === vacanteId,
      );
      // Buscar info de la vacante padre
      const vacanteInfo = _vacantes.find((v) => v.vacante_id === vacanteId);
      //  Construir filas para la tabla
      const filas = asignacionesDeEstaVacante.map((a) => {
        const prueba = _pruebasCatalogo.find((cat) => cat.id === a.pruebas_y_otros);
        return {
          id: a.id, // id único de la asignación
          vacanteCodigo: vacanteInfo?.vacante__folio || '—',
          vacantePlaza: vacanteInfo?.vacante_plaza_clave_y_descripcion || '—',
          vacanteAreaNombre: vacanteInfo?.vacante_directorio_de_area_clave_y_nombre || '—',
          vacantePruebas: prueba ? [prueba.descripcion] : [`Prueba #${a.pruebas_y_otros}`],
        };
      });
      setData(filas);
      setPruebasVacantes(_pruebasCatalogo);
      setVacantes(_vacantes);
    } catch (error) {
      message.error('No se pudieron recargar las pruebas asignadas.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();

      const [
        _vacantes,
        _pruebasCatalogo,
        _asignaciones,
      ] = await Promise.all([
        getSolicitudDeContratacionvistaOptimized(), // datos descriptivos de vacantes
        getPruebas(), // catálogo de pruebas
        getSolicitudPruebas(), // asignaciones
      ]);

      if (mounted) {
      // 🔗 Filtrar solo las asignaciones de la vacante seleccionada
        const asignacionesDeEstaVacante = _asignaciones.filter(
          (a) => a.solicitud_de_contratacion === vacanteId,
        );

        // Buscar info de la vacante
        const vacanteInfo = _vacantes.find((v) => v.vacante_id === vacanteId);

        // 🔁 Construir una fila por cada asignación
        const filas = asignacionesDeEstaVacante.map((a) => {
          const prueba = _pruebasCatalogo.find((cat) => cat.id === a.pruebas_y_otros);
          return {
            id: a.id, // id único de la asignación
            vacanteCodigo: vacanteInfo?.vacante__folio || '—',
            vacantePlaza: vacanteInfo?.vacante_plaza_clave_y_descripcion || '—',
            vacanteAreaNombre: vacanteInfo?.vacante_directorio_de_area_clave_y_nombre || '—',
            vacantePruebas: prueba ? [prueba.descripcion] : [`Prueba #${a.pruebas_y_otros}`],
          };
        });

        setData(filas);
        setPruebasVacantes(_pruebasCatalogo);
        setVacantes(_vacantes);

        setLoading(false);
      }
    };
    fetchAll();
    return () => {
      mounted = false;
    };
  }, [vacanteId]);
  useEffect(() => {
    if (vacanteId) {
      setVacanteSeleccionada({ id: vacanteId });
    }
  }, [vacanteId]);
  const columnsVacantes = [
    // {
    //   titleText: 'ID',
    //   dataIndex: 'id',
    // },
    // { titleText: 'Código', dataIndex: 'vacanteCodigo' },
    // { titleText: 'Vacante', dataIndex: 'vacantePlaza' },
    // { titleText: 'Área', dataIndex: 'vacanteAreaNombre' },
    {
      titleText: 'Pruebas Asignadas',
      dataIndex: 'vacantePruebas',
      render: (pruebas) => (Array.isArray(pruebas) && pruebas.length > 0 ? pruebas.join(', ') : '—'),
    },
  ];

  //  función para abrir modal de asignar pruebas
  const onClickAsignarPruebas = () => {
    if (!vacanteId) {
      message.error('No se recibió una vacante desde el padre.');
      return;
    }

    const targetVacante = vacantes.find((v) => v.vacante_id === vacanteId);

    if (!targetVacante) {
      message.error('No se encontró la vacante correspondiente.');
      return;
    }

    //  Mapea correctamente para que el modal reciba lo que espera
    setVacanteSeleccionada({
      ...targetVacante,
      solicitud_de_contratacion: targetVacante.vacante_id, //  el campo que pide el backend
    });

    setModalOpen(true);
  };

  //  clic en fila
  const handleOnRowClick = (record) => {
    setSelectedRowKeys([`vac-${record.id}`]); // ojo, porque tu rowKey es `vac-${id}`
    form.setFieldsValue(record);
  };

  //  selección de filas
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  return (
    <div>

      <Table
        data={data}
        cols={columnsVacantes}
        rowKey={(record) => `vac-${record.id}`}
        pagination={false}
        bordered
        rowSelection={rowSelection}
        handleOnRowClick={handleOnRowClick}
        customActions={[
          {
            text: 'Asignar Pruebas',
            // icon: <UsergroupAddOutlined />,
            onClick: onClickAsignarPruebas,
            disabledBySelection: false,
          },
        ]}
      />

      <AsignarPruebasPorVacanteModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        vacante={vacanteSeleccionada} // 👈 ya viene del padre
        pruebasDisponibles={pruebasvacantes}
        onAsignarSuccess={fetchData}
      />
    </div>
  );
}
